/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_P3dInputs */

const en_mk_sol_konsultan_p3d = /** @type {(inputs: Mk_Sol_Konsultan_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The client asks where a number came from. “From the AI” is never an acceptable answer.`)
};

const id_mk_sol_konsultan_p3d = /** @type {(inputs: Mk_Sol_Konsultan_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klien bertanya dari mana angka itu berasal. Jawaban "dari AI" tidak pernah cukup.`)
};

/**
* | output |
* | --- |
* | "The client asks where a number came from. “From the AI” is never an acceptable answer." |
*
* @param {Mk_Sol_Konsultan_P3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_p3d = /** @type {((inputs?: Mk_Sol_Konsultan_P3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_P3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_p3d(inputs)
	return en_mk_sol_konsultan_p3d(inputs)
});